import { cn } from "../../lib/utils";
import { categoryBadgeClass, statusBadgeClass } from "./utils";

const BADGE_BASE =
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium";

export function ExpenseStatusBadge({ status }: { status?: string | null }) {
  return (
    <span className={cn(BADGE_BASE, statusBadgeClass(status))}>
      {status ?? "—"}
    </span>
  );
}

export function ExpenseCategoryBadge({
  category,
}: {
  category?: string | null;
}) {
  if (!category) {
    return <span className="text-[#374151]">—</span>;
  }
  return (
    <span className={cn(BADGE_BASE, categoryBadgeClass(category))}>
      {category}
    </span>
  );
}

export function ExpenseFrequencyBadge({
  frequency,
}: {
  frequency?: string | null;
}) {
  if (!frequency) {
    return <span className="text-[#374151]">—</span>;
  }
  return (
    <span
      className={cn(BADGE_BASE, "border-[#f1edfd] bg-[#f1edfd] text-[#6d28d9]")}
    >
      {frequency}
    </span>
  );
}
